import Icon, { IconName, IconProps } from '@/components/Icon';
import Btn, { BtnComponentWithRef, BtnProps } from '@/components/ui/Btn';
import { Polymorphic } from '@/components/ui/Polymorphic';
import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import React from 'react';
import * as styles from './IconButton.css';

export type IconButtonBaseProps = {
  icon: IconName;
  IconProps?: Omit<IconProps, 'name'>;
};

export type IconButtonProps<C extends React.ElementType = 'button'> = BtnProps<
  C,
  IconButtonBaseProps
>;

const IconButton: BtnComponentWithRef<IconButtonBaseProps> = React.forwardRef(function IconButton<
  C extends React.ElementType
>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  { icon, IconProps, children, ...props }: Omit<IconButtonProps<C>, 'icon'>,
  ref?: Polymorphic.Ref<C>
) {
  return (
    <Btn ref={ref} square variant="filled" {...mergePropsClassName(props, styles.root)}>
      <Icon name={icon} fontSize="large" className={styles.icon} />
    </Btn>
  );
});

export default IconButton;
